import React, { useEffect, useRef } from "react"
import styled from "@emotion/styled"
import { deviceMinW } from "../../../styles/mediaQueries"

const VideosRight = ({ video }) => {
    const videoEl = useRef(null)

    const attemptPlay = () => {
        videoEl &&
            videoEl.current &&
            videoEl.current.play().catch(error => {
                console.error("Error attempting to play", error)
            })
    }

    useEffect(() => {
        attemptPlay()
    }, [])

    return (
        <>
            {video.columns === "2" && (
                <VideosTwoColumn
                    autoload={true}
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    alt={video.alt}
                    ref={videoEl}
                    src={video.src}
                    poster={video.poster}
                />
            )}
            {video.columns === "1" && (
                <VideosOneColumn
                    autoload={true}
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    alt={video.alt}
                    ref={videoEl}
                    src={video.src}
                    poster={video.poster}
                />
            )}
        </>
    )
}
export default VideosRight

const VideosOneColumn = styled.video`
    width: 100%;
    margin-bottom: 3%;
`

const VideosTwoColumn = styled.video`
    width: 100%;
    margin-bottom: 3%;

    @media ${deviceMinW.tablet} {
        width: 48%;
    }
`
